import { ACTIVITY_FACTORS, MIFFLIN } from './config';
import { parseIsoDate } from './dates';
import { round2 } from './math';
import type { ActivityLevel, Sex } from './types';

/**
 * Edad en anos cumplidos. Se calcula sobre las cadenas 'YYYY-MM-DD' y no con
 * `Date`: construir fechas aqui arrastraria la zona horaria del navegador y
 * haria que alguien cumpliese anos un dia antes segun donde estuviera.
 */
export function ageOn(birthDate: string, onDate: string): number {
  const birth = parseIsoDate(birthDate);
  const on = parseIsoDate(onDate);

  let age = on.year - birth.year;
  // Si aun no ha llegado el dia y mes del cumpleanos, resta un ano.
  if (on.month < birth.month || (on.month === birth.month && on.day < birth.day)) age -= 1;
  return age;
}

export interface BmrInput {
  sex: Sex;
  weightKg: number;
  heightCm: number;
  ageYears: number;
}

/**
 * Metabolismo basal por Mifflin-St Jeor (SPEC 6.A).
 *   hombre: 10*peso + 6,25*altura - 5*edad + 5
 *   mujer:  10*peso + 6,25*altura - 5*edad - 161
 */
export function bmrMifflinStJeor({ sex, weightKg, heightCm, ageYears }: BmrInput): number {
  if (!(weightKg > 0)) throw new Error('El peso debe ser mayor que 0');
  if (!(heightCm > 0)) throw new Error('La altura debe ser mayor que 0');
  if (!(ageYears >= 0)) throw new Error('La edad no puede ser negativa');

  const base = MIFFLIN.perKg * weightKg + MIFFLIN.perCm * heightCm - MIFFLIN.perYear * ageYears;
  return round2(base + (sex === 'hombre' ? MIFFLIN.hombre : MIFFLIN.mujer));
}

/** Gasto total = BMR x factor de actividad (1,2 a 1,9). */
export function tdeeFromBmr(bmr: number, activity: ActivityLevel): number {
  return round2(bmr * ACTIVITY_FACTORS[activity]);
}
